import { graphql } from "react-relay";

export const teamSettingsSearchFragments = {
  viewer: graphql`
    fragment TeamSettingsSearch_viewer on Viewer
    @argumentDefinitions(
      queryInput: { type: "String!", defaultValue: "" }
      orgRelayId: { type: "ID!" }
      excludeCalendars: { type: "[String]" }
    ) {
      orgPersonQueryResultErrorable(
        query: $queryInput
        orgRelayId: $orgRelayId
        excludeCalendars: $excludeCalendars
      ) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on OrgPersonQueryResult {
          query
          persons {
            __typename
            calendarAliases
            redirectPersonId
            personId
            id
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
            redirectPersonId
            calendarAliases
          }
        }
      }
    }
  `,
  org: graphql`
    fragment TeamSettingsSearch_org on Org {
      ...TeamSettingsTeammate_org
      id
      primaryOrgCalendar
      workingGroups(first: 1000000) {
        edges {
          node {
            calendarIds
          }
        }
      }
    }
  `,
  team: graphql`
    fragment TeamSettingsSearch_team on Team {
      id
      teamId
      teamName
      createdBy {
        type
        value
      }
      teamMembers {
        role
        person {
          __typename
          calendarAliases
          redirectPersonId
          id
          primaryCalendarId
          isYou
          userId
          profile {
            givenName
            familyName
            externalImageUrl
          }
          redirectPersonId
          calendarAliases
        }
      }
      invitedMembers {
        role
        person {
          __typename
          calendarAliases
          redirectPersonId
          id
          primaryCalendarId
          isYou
          userId
          profile {
            givenName
            familyName
            externalImageUrl
          }
          redirectPersonId
          calendarAliases
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query TeamSettingsSearchQuery(
    $queryInput: String!
    $orgRelayId: ID!
    $excludeCalendars: [String]
  ) {
    viewer {
      ... on Viewer {
        ...TeamSettingsSearch_viewer
          @arguments(
            queryInput: $queryInput
            orgRelayId: $orgRelayId
            excludeCalendars: $excludeCalendars
          )
      }
    }
  }
`;
